import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Mail, ArrowRight } from "lucide-react";

const SignupThankYou = () => {
  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center px-4">
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-50 via-green-100 to-teal-50"></div>

      {/* Gradient overlay with better contrast */}
      <div className="absolute inset-0 bg-gradient-to-b from-green-600/15 via-emerald-500/10 to-teal-600/15"></div>

      {/* Gradient orbs for depth */}
      <div className="absolute -top-32 -left-32 w-96 h-96 bg-gradient-to-r from-green-400/30 to-emerald-400/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute top-1/4 right-1/3 w-72 h-72 bg-gradient-to-r from-teal-300/25 to-green-300/35 rounded-full blur-2xl"></div>
      <div className="absolute -bottom-24 -right-24 w-80 h-80 bg-gradient-to-r from-emerald-400/25 to-teal-400/30 rounded-full blur-3xl"></div>

      {/* Accent orb */}
      <div className="absolute top-3/4 left-1/5 w-48 h-48 bg-gradient-to-r from-green-200/40 to-emerald-200/30 rounded-full blur-2xl"></div>

      {/* Thank You Content */}
      <div className="flex items-center justify-center px-4 py-16 relative z-10">
        <div className="w-full max-w-md">
          <Card className="text-center">
            <CardHeader>
              <div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                <Mail className="w-8 h-8 text-blue-600" />
              </div>
              <CardTitle className="text-2xl text-green-800">
                Account Created Successfully!
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="space-y-4">
                <h3 className="text-lg font-semibold text-gray-900">
                  Please Check Your Email
                </h3>
                <p className="text-gray-600">
                  We've sent you a confirmation email. Please click the link in
                  the email to verify your account and complete the registration
                  process.
                </p>
                <p className="text-sm text-gray-500">
                  Don't see the email? Check your spam or junk folder.
                </p>
              </div>

              <div className="border-t pt-6">
                <p className="text-sm text-gray-600 mb-4">
                  Already confirmed your email?
                </p>
                <Link to="/login">
                  <Button className="w-full bg-green-700 hover:bg-green-800">
                    Sign In to Your Account
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Button>
                </Link>
              </div>

              <div className="text-center">
                <Link
                  to="/"
                  className="text-sm text-green-700 hover:text-green-800"
                >
                  Return to Homepage
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default SignupThankYou;
